import { Component, OnInit, Inject, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { NewRelicService } from '../../../../angular-app/projects/brokerage-eapp/src/app/services/newrelic.service';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';

// store
import { AppState } from 'projects/brokerage-eapp/src/app/app-reducer';
import { Store } from '@ngrx/store';
import { first } from 'rxjs/operators';

// services
import { ApiService } from '../services/api.service';
import { NavigationService } from 'projects/brokerage-eapp/src/app/services/navigation.service';
import { forEach } from 'lodash';
import { AppConstants } from 'projects/brokerage-eapp/src/app/app.constants';


@Component({
  selector: 'app-modal-component',
  templateUrl: './modal.component.html'
})

export class ModalComponent implements OnInit {
  // Base settings
  screenIndex: number = 0;
  appState$: Observable<any>;
  private appId: string;
  // Producer Send Email settings
  processing: boolean = false;
  @Output() emailSentForAppId: EventEmitter<any> = new EventEmitter<any>();
  exceededEmailAPIAttempts: boolean = false;
  // Unlock application
  @Output() unlockedForAppId: EventEmitter<boolean> = new EventEmitter<boolean>();
  // Resend to owners
  @Output() resendToOwnersEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  // Demo
  isDemo: boolean = false;
  // Mismatch info
  mismatchWarningStrings: any;
  mismatchWarningStringsEdited: any;
  @Output() continue: EventEmitter<any> = new EventEmitter<any>();
  // General
  userRole: string;
  customerSigned: boolean = false;



  constructor(
    private newRelicService: NewRelicService,
    public router: Router,
    public dialogRef: MatDialogRef<ModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private apiService: ApiService,
    private navigationService: NavigationService,
    private cdr: ChangeDetectorRef,
    private store: Store<AppState>,
    private appConstants: AppConstants
  ) {
    this.appState$ = store.select('sections');
  }

  ngOnInit() {
    this.appState$.pipe(first()).subscribe((state: any) => {
      this.appId = state.appId;

      // Log component initialization
      this.newRelicService.addPageAction('ModalComponent Init', { appId: this.appId });
    });

    this.dialogRef.updateSize('auto', 'auto');

    // For email initialization errors
    if (this.data.emailInitError) {
      this.handleEmailFailure();
    }

    // For mismatch data
    // if(this.data.modalType === 'mismatch') {
    //   console.log('hi', this.data.flaggedValues.value);
    //   this.mismatchWarningStrings = this.data.flaggedValues.value;
    //   this.data.mismatchWarningStrings = this.mismatchWarningStrings;
    // }

    // For demo
    this.appState$.pipe(first()).subscribe((state: any) => {
      if(state) {
        this.isDemo = state.isDemo;
        this.customerSigned = state.content.DeclarationsInsured ? state.content.DeclarationsInsured.FinalSignature ? true : false : false;
      }
    });

  }

  // Modal functions
  close() {
    this.dialogRef.updateSize('auto', 'auto');
    this.dialogRef.close();
  }

  transitionToScreen(desiredScreenIndex) {
    if(this && this.data && this.data.screens) {
      this.data.screens[this.screenIndex].show = false;
      this.data.screens[desiredScreenIndex].show = true;
      this.screenIndex = desiredScreenIndex;
    }
  }

  validateSizing(modalSize: string, className: string) {
    const valid_sizes = [
      'small',
      'medium',
      'large'
    ];
    return valid_sizes.includes(modalSize) ? className + '-' + this.data.size : className;
  }

  // Navigation functions
  goToAgentPortal() {
    this.navigationService.nextSectionRelative('financial-professional');
    this.close();
  }

  goToAgentPortalDemo() {
    this.navigationService.nextSectionRelativeNewWindowDemo('financial-professional');
    this.close();
  }

  goToCustomerAuthenticationPage() {
    this.navigationService.nextSectionRelative('find-application');
    this.close();
  }

  goSignApp() {

    // submits the block from DynamicFormComponent
    this.navigationService.fireSubmit(true);

    //console.log('go sign app');
    const path = this.customerSigned === false ? 'express/disclosures' : 'express/agent-report';
    // console.log('go sign app path: ', path);
    this.navigationService.nextSection(path);
    this.close();
  }

  // Illustration functions
  retryUpload() {
    this.dialogRef.close({ event: 'Retry' });
  }

  continueIllustrationCertification() {
    this.dialogRef.close({ event: 'Continue' });
  }
  closeModal() {
    this.dialogRef.close();
  }
  startWithoutIllustration() {
    this.dialogRef.close({ event: 'startWithoutIllustration' });
  }
  startWithIllustration() {
    this.dialogRef.close({ event: 'startWithIllustration' });
  }
  // Email functions
  sendEmail() {

    // submits the block from DynamicFormComponent
    this.navigationService.fireSubmit(true);

    let unlocked = false;

    this.setEqualHeight();

    this.appState$.subscribe((state: any) => {
      if (state && state.unlocked) {
        unlocked = true;
      }
    });

    if (this.data.ProposedInsuredEmailAddress && this.data.ProposedInsuredName && this.data.AppId) {
      this.processing = true;
      this.cdr.detectChanges();
      console.log('Sending to customer');
      const emailInfo = {
        emailInfo: {
          AppId: this.data.AppId,
          AgentId: this.data.AgentId,
          Subject: this.appConstants.brokerageEappTitle,
          To: [
            {
              email: this.data.ProposedInsuredEmailAddress, name: this.data.ProposedInsuredName
            }]
        }
      };

      if (!unlocked) {
        try {
          this.newRelicService.addPageAction('Send Email Start', { appId: this.appId });

          if (this.isDemo) {
            this.apiService.sendDemoJHEmail(emailInfo).subscribe((response) => {
              if (response.data.Message === 'Mail Sent' || response.data.Message === this.appConstants.emailAccepted) {

                //added scaffolding for stage email issue.
                console.log("Demo Locked Email Success");
                this.handleEmailSuccess();
              } else {
                //added scaffolding for stage email issue.
                console.log("Demo Locked Email Failure");
                this.handleEmailFailure();
              }
            }, (error) => {
              this.newRelicService.noticeError(error, { appId: this.appId });
              this.handleEmailFailure();
            });
          } else {
            this.apiService.sendJHEmail(emailInfo).subscribe((response) => {
              if (response.data.Message === 'Mail Sent' || response.data.Message === this.appConstants.emailAccepted) {
                this.newRelicService.addPageAction('Send Email Success', { appId: this.appId });
                this.handleEmailSuccess();
              } else {
                this.newRelicService.addPageAction('Send Email Failure', { appId: this.appId });
                this.handleEmailFailure();
              }
            }, (error) => {
              this.newRelicService.noticeError(error, { appId: this.appId });
              this.handleEmailFailure();
            });
          }
        } catch (e) {
          this.newRelicService.noticeError(e, { appId: this.appId });
          console.log(e);
          this.handleEmailFailure();
        }
      } else {
        try {
          this.newRelicService.addPageAction('Send Unlock Email Start', { appId: this.appId });

          this.apiService.sendJHUnlockEmail(emailInfo).subscribe((response) => {
            if (response.data.Message === 'Mail Sent' || response.data.Message === this.appConstants.emailAccepted) {
              this.newRelicService.addPageAction('Send Unlock Email Success', { appId: this.appId });
              this.handleEmailSuccess();
            } else {
              this.newRelicService.addPageAction('Send Unlock Email Failure', { appId: this.appId });
              this.handleEmailFailure();
            }
          }, (error) => {
            this.newRelicService.noticeError(error, { appId: this.appId });
            this.handleEmailFailure();
          });
        } catch (e) {
          this.newRelicService.noticeError(e, { appId: this.appId });
          console.log(e);
          this.handleEmailFailure();
        }
      }

    } else {

      this.processing = true;
      console.log('Missing customer info in payload. Cannot send email.');
      setTimeout(() => this.handleEmailFailure(), 350);
    }
  }

  handleEmailFailure() {
    if (this.exceededEmailAPIAttempts) {
      // Show retry content
      this.processing = false;
      this.cdr.detectChanges();
      this.transitionToScreen(3);
    } else {
      this.processing = false;
      this.cdr.detectChanges();
      this.transitionToScreen(2);
      this.exceededEmailAPIAttempts = true;
    }
  }

  handleEmailSuccess() {
    this.emailSentForAppId.emit(this.data.AppId);
    this.processing = false;
    this.cdr.detectChanges();
    this.transitionToScreen(1);
  }

  handleTestStep() {
    console.log('This is a test for keeping modal height size');

    this.processing = true;

    this.setEqualHeight();

    setTimeout(() => {
      this.handleEmailFailure();
      this.transitionToScreen(2);
    }, 350);
  }

  setEqualHeight() {

    let modalWidth;
    let modalHeight;

    if(document.querySelector('.mat-dialog-container') && document.querySelector('.mat-dialog-container').clientHeight) {
      modalHeight = document.querySelector('.mat-dialog-container').clientHeight ?? 500;
      modalWidth = document.querySelector('.mat-dialog-container').clientWidth ?? 500;
    }


    this.dialogRef.updateSize(`${modalWidth}px`, `${modalHeight}px`);
  }

  // Unlock Applicatiom
  unlock() {
    //console.log('unlock');
    this.unlockedForAppId.emit(true);
  }

  // Resend to Owners
  resendToOwners() {
    this.sendOwnersEmail();
    //console.log('resend to owners');
    this.resendToOwnersEvent.emit(true);
  }
  // TODO Timeout functions

  // TODO Customer authentication functions

  // TODO Pending payloads functions

  // TODO Duplicate application functions


  // Email reminders for Owners
  sendOwnersEmail() {

    this.exceededEmailAPIAttempts = true;

    // submits the block from DynamicFormComponent
    this.navigationService.fireSubmit(true);

    let unlocked = false;

    this.setEqualHeight();


    //TO DO
    //check if PI as signed
    //if no- send email
    //loop owners, if not signed, send reminder
    //for all, if sent reminder- update sent email date

    this.appState$.subscribe((state: any) => {
      if (state && state.unlocked) {
        unlocked = true;
      }
    });

    //proposed insured reminder
    if (this.data.ProposedInsuredEmailAddress && this.data.ProposedInsuredName && this.data.AppId) {
      this.processing = true;
      this.cdr.detectChanges();

      //proposed insured email if unsigned
      if (this.data.ProposedInsuredSigned == 0) {
        const emailInfo = {
          emailInfo: {
            AppId: this.data.AppId,
            Subject: this.appConstants.brokerageEappTitle,
            To: [
              {
                email: this.data.ProposedInsuredEmailAddress, name: this.data.ProposedInsuredName
              }]
          }
        };
        try {
          this.apiService.sendJHEmail(emailInfo).subscribe((response) => {
            if (response.data.Message === 'Mail Sent' || response.data.Message === this.appConstants.emailAccepted) {
              this.handleEmailSuccess();
            } else {
              this.handleEmailFailure();
            }
          });

        } catch (e) {
          console.log(e);
          this.handleEmailFailure();
        }
      }
      else {

        const unsignedOwners = this.data.OwnersInformation.filter(x=> !x.Signed);
        console.log(unsignedOwners);
        this.processing = true;
        this.cdr.detectChanges();
        const responses = [];
        //loop through owners to determine who needs to get a reminder email
        unsignedOwners.filter(x=> !x.Signed).forEach((owner, index) => {

          console.log(owner);

          //if the owner is unsigned, send email
          // if (!owner.Signed) {
          const emailInfo = {
            emailInfo: {
              AppId: this.data.AppId,
              Subject: this.appConstants.brokerageEappTitle,
              OwnerLastName: owner.LastName,
              OwnerFirstName: owner.FirstName,
              OwnerType: owner.Role,
              To: [
                {
                  email: owner.SignerEmail, name: this.data.ProposedInsuredName
                }]
            }
          };
          try {
            this.apiService.sendOwnerEmail(emailInfo).subscribe((response) => {

              responses.push(response.data.Message);
              if (response.data.Message === 'Mail Sent'|| response.data.Message === this.appConstants.emailAccepted) {
                this.handleEmailSuccess();

              } else {
                this.handleEmailFailure();

              }

            });

          } catch (e) {

            console.log(e);
            this.handleEmailFailure();

          }
          //}
        });


      }

    }


  }
}
